import React from 'react';
import { CollapsablePanel } from '@app/app/_components/CollapsablePanel/CollapsablePanel';
import { ReadOnlyField } from '@app/app/_components/ReadOnlyField/ReadOnlyField';
import { TextButton } from '@app/app/_components/TextButton/TextButton';
import { InsuredPerson } from '@app/domain/model/eshop/personal-accidents/InsuredPerson';
import { useTranslations } from 'next-intl';

interface Props {
    insuredPersons: InsuredPerson[];
    editInsuredPeople: () => void;
}

export function InsuredPeopleSummaryCard({ insuredPersons, editInsuredPeople }: Props) {
    const t = useTranslations();

    return (
        <CollapsablePanel
            addon={
                <TextButton onClick={editInsuredPeople} preventDefault>
                    {t('general.edit')}
                </TextButton>
            }
            collapsable={false}
            label={t('eshop.personalAccidents.summaryStep.allInsuredPeople')}>
            <div className="grid w-full grid-cols-2 gap-4 px-6 pt-6">
                {insuredPersons.map(person => (
                    <React.Fragment key={person.id}>
                        <ReadOnlyField
                            label={t(
                                'eshop.personalAccidents.summaryStep.nameSurname',
                            )}>{`${person.name} ${person.surname}`}</ReadOnlyField>
                        <ReadOnlyField label={t('eshop.personalAccidents.summaryStep.personalCode')}>
                            {person.personalCode}
                        </ReadOnlyField>
                    </React.Fragment>
                ))}
            </div>
        </CollapsablePanel>
    );
}
